import { useEffect } from "react";

const SITE = "BRaIN | Bengaluru Research and Innovation Network";
export const SITE_ORIGIN = new URL(process.env.REACT_APP_BACKEND_URL).origin;
const DEFAULT_IMAGE = `${SITE_ORIGIN}/icon-512.png`;
const DEFAULT_DESCRIPTION = "BRaIN, the Bengaluru Research and Innovation Network, connects researchers, institutions, industry, startups, government and investors to turn Bengaluru research and innovation into impact.";

const upsert = (selector, create, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(create);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};
const setMeta = (attr, key, content) => upsert(`meta[${attr}="${key}"]`, "meta", { [attr]: key, content });

export const absoluteUrl = (url) => (!url ? DEFAULT_IMAGE : /^https?:\/\//.test(url) ? url : `${SITE_ORIGIN}${url.startsWith("/") ? "" : "/"}${url}`);

// Sets title, description, canonical URL, social tags and optional JSON-LD for the current page.
export function usePageMeta(title, description, opts) {
  const { image, type = "website", jsonLd } = opts || {};
  const ld = jsonLd ? JSON.stringify(jsonLd).replace(/</g, "\\u003c") : "";
  useEffect(() => {
    const fullTitle = title ? `${title} | BRaIN Bengaluru` : SITE;
    const url = `${SITE_ORIGIN}${window.location.pathname}`;
    document.title = fullTitle;
    const desc = description || DEFAULT_DESCRIPTION;
    setMeta("name", "description", desc);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);
    setMeta("property", "og:image", absoluteUrl(image));
    upsert('link[rel="canonical"]', "link", { rel: "canonical", href: url });
    document.getElementById("page-jsonld")?.remove();
    if (ld) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "page-jsonld";
      s.text = ld;
      document.head.appendChild(s);
    }
  }, [title, description, image, type, ld]);
}
